var _style, _path, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHxUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bandera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.4 453.2",
    style: {
      enableBackground: "new 0 0 511.4 453.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000129194989856633751300000009621012587058817170_);fill:#CA2027;}\n\t.st1{clip-path:url(#SVGID_00000129194989856633751300000009621012587058817170_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000129194989856633751300000009621012587058817170_);fill:#2B3561;}\n\t.st3{clip-path:url(#SVGID_00000129194989856633751300000009621012587058817170_);}\n\t.st4{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,0H149c-15.1,0-29.1,8.1-36.7,21.2L5.7,205.4c-7.6,13.1-7.6,29.4,0,42.5L112.3,432c7.6,13.1,21.6,21.2,36.7,21.2 h213.4c15.1,0,29.1-8.1,36.7-21.2l106.6-184.2c7.6-13.1,7.6-29.4,0-42.5L399.1,21.2C391.5,8.1,377.5,0,362.4,0L362.4,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M118.3,432.8L8.4,242.5c-5.7-9.8-5.7-22,0-31.8L118.3,20.4c5.7-9.8,16.2-15.9,27.6-15.9h219.7 c11.4,0,21.9,6.1,27.5,15.9L503,210.7c5.7,9.8,5.7,22,0,31.8L393.1,432.8c-5.7,9.8-16.2,15.9-27.5,15.9H145.9 C134.5,448.7,124,442.7,118.3,432.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000055709093323393760820000015211684493595559089_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 414.6,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 38.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 380.4,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#FFFFFF"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 346.2,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 34.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 312.1,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#FFFFFF"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 277.9,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 243.7,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#FFFFFF"
    },
    width: 511.1,
    height: 34.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 209.5,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 175.4,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#FFFFFF"
    },
    width: 511.1,
    height: 34.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 141.2,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 107,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#FFFFFF"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 72.9,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 38.7,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#FFFFFF"
    },
    width: 511.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#CA2027"
    },
    width: 511.1,
    height: 38.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -71.3,
    y: 4.5,
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)",
      fill: "#2B3561"
    },
    width: 347.8,
    height: 239.2
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000055709093323393760820000015211684493595559089_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-39.9,30.9 -37,39.9 -27.4,39.9 -35.1,45.5 -32.2,54.6 -39.9,49 -47.6,54.6 -44.6,45.5 -52.3,39.9  -42.9,39.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-39.9,70.8 -37,79.8 -27.4,79.8 -35.1,85.4 -32.2,94.5 -39.9,88.9 -47.6,94.5 -44.6,85.4 -52.3,79.8  -42.9,79.8  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-39.9,110.8 -37,119.8 -27.4,119.8 -35.1,125.3 -32.2,134.4 -39.9,128.8 -47.6,134.4 -44.6,125.3  -52.3,119.8 -42.9,119.8  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-39.9,150.7 -37,159.7 -27.4,159.7 -35.1,165.3 -32.2,174.3 -39.9,168.8 -47.6,174.3 -44.6,165.3  -52.3,159.7 -42.9,159.7  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-39.9,190.6 -37,199.7 -27.4,199.7 -35.1,205.2 -32.2,214.2 -39.9,208.7 -47.6,214.2 -44.6,205.2  -52.3,199.7 -42.9,199.7  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-12.1,51.9 -9.3,61 0.3,61 -7.4,66.6 -4.5,75.6 -12.1,70 -19.8,75.6 -16.9,66.6 -24.5,61 -15,61  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-12.1,91.8 -9.3,100.9 0.3,100.9 -7.4,106.5 -4.5,115.5 -12.1,109.9 -19.8,115.5 -16.9,106.5  -24.5,100.9 -15,100.9  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-12.1,131.8 -9.3,140.8 0.3,140.8 -7.4,146.4 -4.5,155.4 -12.1,149.9 -19.8,155.4 -16.9,146.4  -24.5,140.8 -15,140.8  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-12.1,171.7 -9.3,180.8 0.3,180.8 -7.4,186.3 -4.5,195.4 -12.1,189.7 -19.8,195.4 -16.9,186.3  -24.5,180.8 -15,180.8  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16,30.9 19,39.9 28.5,39.9 20.8,45.5 23.8,54.6 16,49 8.4,54.6 11.3,45.5 3.6,39.9 13.1,39.9  "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16,70.8 19,79.8 28.5,79.8 20.8,85.4 23.8,94.5 16,88.9 8.4,94.5 11.3,85.4 3.6,79.8 13.1,79.8  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16,110.8 19,119.8 28.5,119.8 20.8,125.3 23.8,134.4 16,128.8 8.4,134.4 11.3,125.3 3.6,119.8  13.1,119.8  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16,150.7 19,159.7 28.5,159.7 20.8,165.3 23.8,174.3 16,168.8 8.4,174.3 11.3,165.3 3.6,159.7  13.1,159.7  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16,190.6 19,199.7 28.5,199.7 20.8,205.2 23.8,214.2 16,208.7 8.4,214.2 11.3,205.2 3.6,199.7  13.1,199.7  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "43.8,51.9 46.8,61 56.3,61 48.6,66.6 51.5,75.6 43.8,70 36.2,75.6 39.1,66.6 31.4,61 40.9,61  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "43.8,91.8 46.8,100.9 56.3,100.9 48.6,106.5 51.5,115.5 43.8,109.9 36.2,115.5 39.1,106.5  31.4,100.9 40.9,100.9  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "43.8,131.8 46.8,140.8 56.3,140.8 48.6,146.4 51.5,155.4 43.8,149.9 36.2,155.4 39.1,146.4  31.4,140.8 40.9,140.8  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "43.8,171.7 46.8,180.8 56.3,180.8 48.6,186.3 51.5,195.4 43.8,189.7 36.2,195.4 39.1,186.3  31.4,180.8 40.9,180.8  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72,30.9 75,39.9 84.4,39.9 76.7,45.5 79.8,54.6 72,49 64.3,54.6 67.2,45.5 59.6,39.9 69.1,39.9  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72,70.8 75,79.8 84.4,79.8 76.7,85.4 79.8,94.5 72,88.9 64.3,94.5 67.2,85.4 59.6,79.8 69.1,79.8  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72,110.8 75,119.8 84.4,119.8 76.7,125.3 79.8,134.4 72,128.8 64.3,134.4 67.2,125.3 59.6,119.8  69.1,119.8  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72,150.7 75,159.7 84.4,159.7 76.7,165.3 79.8,174.3 72,168.8 64.3,174.3 67.2,165.3 59.6,159.7  69.1,159.7  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72,190.6 75,199.7 84.4,199.7 76.7,205.2 79.8,214.2 72,208.7 64.3,214.2 67.2,205.2 59.6,199.7  69.1,199.7  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "99.8,51.9 102.8,61 112.3,61 104.6,66.6 107.5,75.6 99.8,70 92.2,75.6 95.1,66.6 87.4,61 96.9,61  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "99.8,91.8 102.8,100.9 112.3,100.9 104.6,106.5 107.5,115.5 99.8,109.9 92.2,115.5 95.1,106.5  87.4,100.9 96.9,100.9  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "99.8,131.8 102.8,140.8 112.3,140.8 104.6,146.4 107.5,155.4 99.8,149.9 92.2,155.4 95.1,146.4  87.4,140.8 96.9,140.8  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "99.8,171.7 102.8,180.8 112.3,180.8 104.6,186.3 107.5,195.4 99.8,189.7 92.2,195.4 95.1,186.3  87.4,180.8 96.9,180.8  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "127.9,30.9 130.9,39.9 140.4,39.9 132.7,45.5 135.7,54.6 127.9,49 120.3,54.6 123.2,45.5 115.5,39.9  125,39.9  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "127.9,70.8 130.9,79.8 140.4,79.8 132.7,85.4 135.7,94.5 127.9,88.9 120.3,94.5 123.2,85.4  115.5,79.8 125,79.8  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "127.9,110.8 130.9,119.8 140.4,119.8 132.7,125.3 135.7,134.4 127.9,128.8 120.3,134.4 123.2,125.3  115.5,119.8 125,119.8  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "127.9,150.7 130.9,159.7 140.4,159.7 132.7,165.3 135.7,174.3 127.9,168.8 120.3,174.3 123.2,165.3  115.5,159.7 125,159.7  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "127.9,190.6 130.9,199.7 140.4,199.7 132.7,205.2 135.7,214.2 127.9,208.7 120.3,214.2 123.2,205.2  115.5,199.7 125,199.7  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "155.8,51.9 158.7,61 168.3,61 160.6,66.6 163.5,75.6 155.8,70 148.1,75.6 151.1,66.6 143.4,61  152.9,61  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "155.8,91.8 158.7,100.9 168.3,100.9 160.6,106.5 163.5,115.5 155.8,109.9 148.1,115.5 151.1,106.5  143.4,100.9 152.9,100.9  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "155.8,131.8 158.7,140.8 168.3,140.8 160.6,146.4 163.5,155.4 155.8,149.9 148.1,155.4 151.1,146.4  143.4,140.8 152.9,140.8  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "155.8,171.7 158.7,180.8 168.3,180.8 160.6,186.3 163.5,195.4 155.8,189.7 148.1,195.4 151.1,186.3  143.4,180.8 152.9,180.8  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184,30.9 186.9,39.9 196.4,39.9 188.7,45.5 191.6,54.6 184,49 176.3,54.6 179.2,45.5 171.5,39.9  181,39.9  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184,70.8 186.9,79.8 196.4,79.8 188.7,85.4 191.6,94.5 184,88.9 176.3,94.5 179.2,85.4 171.5,79.8  181,79.8  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184,110.8 186.9,119.8 196.4,119.8 188.7,125.3 191.6,134.4 184,128.8 176.3,134.4 179.2,125.3  171.5,119.8 181,119.8  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184,150.7 186.9,159.7 196.4,159.7 188.7,165.3 191.6,174.3 184,168.8 176.3,174.3 179.2,165.3  171.5,159.7 181,159.7  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184,190.6 186.9,199.7 196.4,199.7 188.7,205.2 191.6,214.2 184,208.7 176.3,214.2 179.2,205.2  171.5,199.7 181,199.7  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.8,51.9 214.7,61 224.2,61 216.6,66.6 219.4,75.6 211.8,70 204,75.6 207,66.6 199.4,61 208.8,61  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.8,91.8 214.7,100.9 224.2,100.9 216.6,106.5 219.4,115.5 211.8,109.9 204,115.5 207,106.5  199.4,100.9 208.8,100.9  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.8,131.8 214.7,140.8 224.2,140.8 216.6,146.4 219.4,155.4 211.8,149.9 204,155.4 207,146.4  199.4,140.8 208.8,140.8  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.8,171.7 214.7,180.8 224.2,180.8 216.6,186.3 219.4,195.4 211.8,189.7 204,195.4 207,186.3  199.4,180.8 208.8,180.8  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.9,30.9 242.9,39.9 252.3,39.9 244.7,45.5 247.6,54.6 239.9,49 232.3,54.6 235.1,45.5 227.5,39.9  237,39.9  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.9,70.8 242.9,79.8 252.3,79.8 244.7,85.4 247.6,94.5 239.9,88.9 232.3,94.5 235.1,85.4  227.5,79.8 237,79.8  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.9,110.8 242.9,119.8 252.3,119.8 244.7,125.3 247.6,134.4 239.9,128.8 232.3,134.4 235.1,125.3  227.5,119.8 237,119.8  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.9,150.7 242.9,159.7 252.3,159.7 244.7,165.3 247.6,174.3 239.9,168.8 232.3,174.3 235.1,165.3  227.5,159.7 237,159.7  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.9,190.6 242.9,199.7 252.3,199.7 244.7,205.2 247.6,214.2 239.9,208.7 232.3,214.2 235.1,205.2  227.5,199.7 237,199.7  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxUs);
export default __webpack_public_path__ + "static/media/hx-us.c2bd0d1142b8224c215b8cff0900f4a7.svg";
export { ForwardRef as ReactComponent };